module.exports = __webpack_public_path__ + "img/mesa_l001j.97bac71a.png";